import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';
import baseDefaults from '../Base/Base.defaults';
import baseTextDefaults from '../BaseText/BaseText.defaults';

export default {
  ...cloneDeep(baseDefaults),
  text: merge(baseTextDefaults, {
    text: `Your text goes here. Always remember the engineers of the future will be poets.`,
  }),
};
